export enum AuthFailureReason {
  IpNotAllowed = 'ip-not-allowed',
  SessionExpired = 'session-expired',
}

export const AUTH_FAILURE_REASON_PARAM = 'reason'
export const AUTH_FAILURE_IP_PARAM = 'ip'

const SERVER_CODE_TO_REASON: Record<string, AuthFailureReason> = {
  IP_NOT_ALLOWED: AuthFailureReason.IpNotAllowed,
  SESSION_EXPIRED: AuthFailureReason.SessionExpired,
}

export type AuthFailure = {
  reason: AuthFailureReason
  ipAddress?: string | null
}

type AuthErrorLike = {
  response?: { code?: unknown; ipAddress?: unknown }
}

export function resolveAuthFailure(error: unknown): AuthFailure | null {
  const response = (error as AuthErrorLike | null)?.response
  const code = typeof response?.code === 'string' ? response.code : undefined
  const reason = code ? SERVER_CODE_TO_REASON[code] : undefined
  if (!reason) {
    return null
  }
  const ipAddress = typeof response?.ipAddress === 'string' ? response.ipAddress : null
  return { reason, ipAddress }
}

export function buildLoginRedirectPath(basePath: string, failure: AuthFailure | null): string {
  if (!failure) {
    return basePath
  }
  const params = new URLSearchParams({ [AUTH_FAILURE_REASON_PARAM]: failure.reason })
  if (failure.ipAddress) {
    params.set(AUTH_FAILURE_IP_PARAM, failure.ipAddress)
  }
  return `${basePath}?${params.toString()}`
}

export function readAuthFailureFromSearch(search: string): AuthFailure | null {
  const params = new URLSearchParams(search)
  const reason = params.get(AUTH_FAILURE_REASON_PARAM)
  const isKnownReason = Object.values(AuthFailureReason).includes(reason as AuthFailureReason)
  if (!reason || !isKnownReason) {
    return null
  }
  return { reason: reason as AuthFailureReason, ipAddress: params.get(AUTH_FAILURE_IP_PARAM) }
}
